import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import McDropdownNew from "../../../../../../components/McDropdown/MCDropdownNew";
import { DekontamineringAvSikkerhetskabinettEnum } from "@mcapps/shared/gkReportConstants";
import { Flex, Paper, Radio, Stack, Title, Box } from "@mantine/core";
import {
  IGKDekontamineringAvSikkerhetskabinettResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
const DekontamineringAvSikkerhetskabinett: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKDekontamineringAvSikkerhetskabinettResultater;
}> = ({ data, onUpdateEditData }) => {
  const TESTMETODER: DekontamineringAvSikkerhetskabinettEnum[] = [
    DekontamineringAvSikkerhetskabinettEnum.INNEISIKKERHETSKABINETT,
    DekontamineringAvSikkerhetskabinettEnum.UTENFORSIKKERHETSKABINETT,
    DekontamineringAvSikkerhetskabinettEnum.TILKOBLETAVKAST,
  ];
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Dekontaminering av sikkerhetskabinett
        </Title>
        <b>Hvilken metode skal brukes?</b>
        <Box w="25%">
          <McDropdownNew
            currentValue={data.inndata.valgtMetode}
            onChange={(_, item) =>
              onUpdateEditData("testResultater.dekontamineringAvSikkerhetskabinett.inndata.valgtMetode", item as string)
            }
            defaultTitle="Hvilken testmetode skal brukes?"
            options={TESTMETODER}
          />
        </Box>
        <Box mt="lg" style={{ width: "50%" }}>
          <b>Utført syklus:</b>
          <div>
            <Stack gap={0}>
              <Radio
                checked={data.inndata.utfoertSyklus === true}
                onChange={() =>
                  onUpdateEditData("testResultater.dekontamineringAvSikkerhetskabinett.inndata.utfoertSyklus", true)
                }
                label="Utført"
              />
              <Radio
                checked={data.inndata.utfoertSyklus === false}
                onChange={() =>
                  onUpdateEditData("testResultater.dekontamineringAvSikkerhetskabinett.inndata.utfoertSyklus", false)
                }
                label="Ikke utført"
              />
            </Stack>
          </div>
        </Box>
        <Flex direction="column" mt="lg">
          <McInputNew
            label="Fyll inn syklusstart (-):"
            value={data.inndata.syklusstart}
            onChange={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvSikkerhetskabinett.inndata.syklusstart", e.target.value)
            }
            type="time"
            style={{ width: "25%" }}
          />
        </Flex>
        <Flex direction="column" mt="sm">
          <McInputNew
            label="Fyll inn syklusslutt (-):"
            value={data.inndata.syklusslutt}
            onChange={(e) =>
              onUpdateEditData("testResultater.dekontamineringAvSikkerhetskabinett.inndata.syklusslutt", e.target.value)
            }
            type="time"
            style={{ width: "25%" }}
          />
        </Flex>
        <Flex direction="column" mt="sm">
          <McInputNew
            label="Fyll inn høyeste PPM (partikler/million):"
            value={data.inndata.hoeyestePPM}
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.dekontamineringAvSikkerhetskabinett.inndata.hoeyestePPM",
                Number(e.target.value),
              )
            }
            normalizeNumbers={true}
            type="text"
            style={{ width: "25%" }}
          />
        </Flex>
        <Flex direction="column" mt="sm">
          <McInputNew
            label="Fyll inn luftfuktighet (%):"
            value={data.inndata.luftfuktighet}
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.dekontamineringAvSikkerhetskabinett.inndata.luftfuktighet",
                Number(e.target.value),
              )
            }
            normalizeNumbers={true}
            type="text"
            style={{ width: "25%" }}
          />
        </Flex>
        <Flex direction="column" mt="sm">
          <McInputNew
            label={
              <>
                {" "}
                Fyll inn temperatur &#40;C<sup>o</sup>&#41;:{" "}
              </>
            }
            value={data.inndata.temperatur}
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.dekontamineringAvSikkerhetskabinett.inndata.temperatur",
                Number(e.target.value),
              )
            }
            normalizeNumbers={true}
            type="text"
            style={{ width: "25%" }}
          />
        </Flex>
        <Box mt="lg">
          <ReportDocxImageContainer docxImageTag="dekontamineringAvSikkerhetskabinett" title="Plassering av sensor" />
          <Box w="50%">
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.dekontamineringAvSikkerhetskabinett.inndata.kommentar", e.target.value)
              }
            />
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};
export default DekontamineringAvSikkerhetskabinett;
